import capital1 from "./1-15.png";
import capital2 from "./2-10.png";
import capital3 from "./2-17.png";
import capital4 from "./4-17.png";
import capital5 from "./5-15-1.png";

const Capital = [capital1, capital2, capital3, capital4, capital5];

export default Capital;
